import { SuperAdminConstants } from '../../../_constants';

const initialState = { getCreditsLoading: true, data: '', error: false };

export function getCreditsReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_CREDITS:
            return {
                getCreditsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_CREDITS:
            return {
                getCreditsLoading: false,
                data: action.getCredits,
                error: false
            };
        case SuperAdminConstants.GET_CREDITS_ERROR:
            return {
                getCreditsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageCredits/getCredits.reducer.js